import React, { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import { pushAdoptsSellerModal } from '../../../Modals/redux/actionCreators';
import { getHasBuyItNow, getAllowOffers, getPrice } from '../../helpers';
import s from './AdoptableSeller.scss';
export const AdoptableSeller = ({ deviation , className  })=>{
    const dispatch = useDispatch();
    const { t  } = useTranslation();
    const openEditModal = useCallback(()=>{
        dispatch(pushAdoptsSellerModal(deviation, 'update'));
    }, [
        deviation,
        dispatch
    ]);
    const openOfferModal = useCallback(()=>{
        dispatch(pushAdoptsSellerModal(deviation, 'offers'));
    }, [
        deviation,
        dispatch
    ]);
    const allowOffers = getAllowOffers(deviation);
    const hasBuyItNow = getHasBuyItNow(deviation);
    const price = getPrice(deviation);
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['status']
    }, allowOffers && !hasBuyItNow && /*#__PURE__*/ React.createElement("span", null, t('actionbar.adoptables.openToOffers')), !allowOffers && hasBuyItNow && /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: 'actionbar.adoptables.adoptForPrice'
    }, "Adopt for $", {
        price
    })), allowOffers && hasBuyItNow && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: 'actionbar.adoptables.adoptForPrice'
    }, "Adopt for $", {
        price
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['subscript']
    }, t('actionbar.adoptables.subtitle')))), /*#__PURE__*/ React.createElement(BuyButton, {
        variant: 'outline',
        size: 'medium',
        rounded: true,
        onClick: openEditModal,
        className: s['offer-button']
    }, t('actionbar.adoptables.editSale')), allowOffers && /*#__PURE__*/ React.createElement(BuyButton, {
        variant: 'outline',
        size: 'medium',
        rounded: true,
        onClick: openOfferModal
    }, t('actionbar.adoptables.viewOffers')));
};
AdoptableSeller.displayName = 'AdoptableSeller';
export default AdoptableSeller;
